import { render, staticRenderFns } from "./contragents-companies.vue?vue&type=template&id=19e2f472"
import script from "./contragents-companies.vue?vue&type=script&lang=js"
export * from "./contragents-companies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports